import { Component, OnInit } from '@angular/core';
import { CustomDataService } from 'src/app/services/custom-data.service';
import * as $ from 'jquery'

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  Url ; show 
  addClass: boolean = false ; 
  constructor(private custom:CustomDataService ) { }
  
  

  ngOnInit() {
    $(document).ready(function(){

    
      
    });
  }
  changeView()
  {
    this.custom.setVideoDisplay(false); 
    this.show = this.custom.getvideoDispaly(); 
    this.custom.setVideoSrc("") ;
    this.Url = this.custom.getVideoSrc();
  }
  getData()
  {
    this.Url  = this.custom.getVideoSrc();
    this.show = this.custom.getvideoDispaly();
    
  }
  change()
  {
    this.addClass = ! this.addClass 
  }
}
